import Service from '../../Services/Service';

const MembershipAPI = {
    getMembershipByBranch(branch_id,lang){
        console.log(`/membership/get_membership_by_branch?branch_id=${branch_id}&lang=${lang}`);
        return Service.get(`/membership/get_membership_by_branch?branch_id=${branch_id}&lang=${lang}`);
    },
    getMembersAll(lang){
        return Service.get('/membership/get_member_all?language='+lang);
    },
    getMemberShipRateByBranch(lang,branch_id){
        return Service.get('/membership/get_membership_rate_with_branch?language='+lang+
        '&branch_id='+branch_id
        );
    },
    getMemberShipBenefitAll(lang){
        return Service.get("/membership/get_membership_benefit_all?language="+lang);
    }
}
export default MembershipAPI
